// src/Dashboard/pages/user/Produits/components/DeveloperHeroCard.jsx

import React from "react";
import {
  FaEnvelope,
  FaExternalLinkAlt,
  FaGlobeEurope,
  FaHeart,
  FaPhoneAlt,
} from "react-icons/fa";

import VKardLink from "./VKardLink";
import { DEVELOPER_PROFILE, DONATION_LINKS } from "../utils/productsUtils";

export default function DeveloperHeroCard() {
  const donationLink = DONATION_LINKS?.[0];

  return (
    <article className="overflow-hidden rounded-[30px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="relative overflow-hidden bg-slate-950 px-5 py-6 text-white sm:px-7">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(76,168,47,0.28),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(1,62,142,0.4),transparent_38%)]" />

        <div className="relative flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-white/60">
              À propos du développeur
            </p>

            <h2 className="mt-2 text-2xl font-bold tracking-tight sm:text-3xl">
              Des applications pensées pour les clubs
            </h2>

            <p className="mt-2 max-w-3xl text-sm leading-6 text-white/80">
              Outils web pour simplifier la gestion des clubs, associations,
              enseignants, dirigeants et adhérents.
            </p>
          </div>

          {donationLink && (
            <a
              href={donationLink.url}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-5 py-3 text-sm font-bold text-slate-950 shadow-lg transition hover:-translate-y-0.5 hover:bg-slate-100"
              title="Soutenir mon travail"
            >
              <FaHeart className="text-rose-500" />
              Soutenir mon travail
              <span className="rounded-full bg-rose-50 px-2 py-0.5 text-xs font-bold text-rose-600">
                Don 5 €
              </span>
            </a>
          )}
        </div>
      </div>

      <div className="p-5 sm:p-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-center">
          <div className="relative mx-auto shrink-0 md:mx-0">
            <div className="absolute -inset-1 rounded-full bg-gradient-to-br from-[#013E8E] via-indigo-500 to-[#4CA82F] opacity-80 blur-sm" />
            <img
              src={DEVELOPER_PROFILE.photo}
              alt={DEVELOPER_PROFILE.name}
              className="relative h-28 w-28 rounded-full object-cover ring-4 ring-white dark:ring-slate-900"
            />
          </div>

          <div className="min-w-0 flex-1 text-center md:text-left">
            <h3 className="text-xl font-bold text-slate-950 dark:text-white">
              {DEVELOPER_PROFILE.name}
            </h3>

            <p className="mt-1 text-sm font-medium text-slate-600 dark:text-slate-300">
              {DEVELOPER_PROFILE.role}
            </p>

            <p className="mt-3 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Passionné de développement d’applications et de judo, je conçois
              des outils simples, modernes et utiles pour gagner du temps dans
              la gestion d’un club ou d’une structure sportive. Merci pour votre contribution, même symbolique, qui m’aide à faire évoluer les projets et à créer de nouvelles applications pour les clubs et enseignants.
            </p>

            <div className="mt-4 flex flex-wrap justify-center gap-2 md:justify-start">
              <a
                href={`mailto:${DEVELOPER_PROFILE.email}`}
                className="inline-flex items-center gap-2 rounded-2xl bg-slate-50 px-3 py-2 text-sm font-bold text-slate-700 ring-1 ring-slate-200 transition hover:bg-slate-100 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-700"
              >
                <FaEnvelope />
                Email
              </a>

              <a
                href={`tel:${DEVELOPER_PROFILE.phoneHref}`}
                className="inline-flex items-center gap-2 rounded-2xl bg-slate-50 px-3 py-2 text-sm font-bold text-slate-700 ring-1 ring-slate-200 transition hover:bg-slate-100 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-700"
              >
                <FaPhoneAlt />
                {DEVELOPER_PROFILE.phoneDisplay}
              </a>

              <a
                href={DEVELOPER_PROFILE.website}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-2xl bg-[#013E8E] px-3 py-2 text-sm font-bold text-white transition hover:bg-indigo-800"
              >
                <FaGlobeEurope />
                MonAppliClub
                <FaExternalLinkAlt className="text-xs opacity-80" />
              </a>

              <VKardLink />

              {donationLink && (
                <a
                  href={donationLink.url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 rounded-2xl bg-rose-50 px-3 py-2 text-sm font-bold text-rose-700 ring-1 ring-rose-200 transition hover:bg-rose-100 dark:bg-rose-900/20 dark:text-rose-200 dark:ring-rose-800/60"
                  title="Faire un don de 5 €"
                >
                  <FaHeart />
                  Don 5 €
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}